export default {
	breaks: [],
	totalBreaks: 0,
	assignedBreaks: [],
	checkedBreaks: [],
	cronExpression: "",
};
